import { Directive } from 'vue'
import authDirective from "./authDirective"
import longpress from "./longpress"
import lazyLoad from "./lazy-load"

const directives: Record<string, Directive> = {
    auth: authDirective,
    longpress: longpress,
    lazyLoad: lazyLoad,
}

export const useCustomDirectives = {
    install: (app: any) => {
        Object.keys(directives).forEach((directiveName) => {
            app.directive(directiveName, directives[directiveName])
        })
    }
}